import React from 'react';
import CheckoutLanding from '../../components/CheckoutLanding';
import LayoutWrapper from '../../components/LayoutWrapper';

const Checkout = () => {
	return (
		<LayoutWrapper>
			<CheckoutLanding />
		</LayoutWrapper>
	);
};

export default Checkout;
